'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/roles', null, {
            default: {method: 'GET'},
        });
    }];